/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';

export default function CustomIdpSignInButton({
  inviteToken = '',
  customIdp,
}) {
  const { t } = useTranslation();

  const { name, id } = customIdp;

  if (!name) {
    return null;
  }

  const description = t('Logga in med {{name}}', {
    name: customIdp?.name,
  });

  return (
    <Button
      size="large"
      variant="contained"
      color="primary"
      component="a"
      href={`/api/login/custom-idp/${id}/login?inviteToken=${inviteToken}`}
    >
      {description}
    </Button>
  );
}
